'use client'

import React from 'react'

import { useCurrency, useLanguages } from '@/hooks'
import { Button, Popover } from '@/components'
import { APP_CURRENCIES } from '@/constants'
import { TCurrency, TFunc } from '@/types'

export const Currency: React.FC = () => {
  const { t } = useLanguages()
  const { currency, onChangeCurrency } = useCurrency()

  const onSelect = (_currency: TCurrency, onClose: TFunc) => () => {
    onChangeCurrency(_currency)
    onClose()
  }

  return (
    <Popover
      WrapEl="li"
      NestedWrapEl="div"
      nestedElementClass="btn-group"
      button={
        <Button className="btn dropdown-toggle">
          {t('formatCurrency', {
            name: currency.name,
            symbol: currency.symbol,
          })}
          <span className="caret"></span>
        </Button>
      }
    >
      {onClose => (
        <ul>
          {APP_CURRENCIES.filter(_v => _v.name !== currency.name).map(
            currency => (
              <li key={currency.name}>
                <p onClick={onSelect(currency, onClose)}>
                  {t('formatCurrency', { ...currency })}
                </p>
              </li>
            ),
          )}
        </ul>
      )}
    </Popover>
  )
}
